// generated — do not hand-edit
export const EVENT_TIERS: Record<string, 1 | 2> = {
  "enrolled": 1, "install-started": 1, "install-succeeded": 1, "install-failed": 1,
  "heartbeat": 1, "update-applied": 1, "update-failed": 1, "consent-changed": 1,
  "identity-mismatch": 1,
  // extended additively for tier-2 usage events: "usage-rollup": 2
};
export const EVENT_ENUM = Object.keys(EVENT_TIERS);
